module.exports = __webpack_public_path__ + "static/media/i_footer_chat_on.da2f4dfe.png";